import { QueryClientProvider } from '@tanstack/react-query';
import { VTooltipProvider } from '@vrzl/ui';
import { Provider as JotaiProvider } from 'jotai';

import { AuthProvider } from '@/domains/auth';
import { queryClient } from '@/domains/general/api/queryClient';
import { PerspectiveTheme } from '@/domains/perspective/perspectiveTheme';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <JotaiProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PerspectiveTheme />
          <VTooltipProvider>{children}</VTooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </JotaiProvider>
  );
}
